import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Plus } from "lucide-react";
import { api, orderImage, statusText } from "@/lib/api";
import { Loading } from "@/components/Loading";
import { stickerSrc } from "@/components/wizard/StepSticker";

export default function Orders() {
  const [orders, setOrders] = useState(null);
  useEffect(() => { api.get("/orders").then(({ data }) => setOrders(data)); }, []);
  if (!orders) return <Loading />;
  return (
    <div className="mx-auto max-w-4xl px-4 py-12 sm:px-8" data-testid="orders-page">
      <div className="flex flex-wrap items-end justify-between gap-4">
        <h1 className="text-4xl font-bold text-[#4A2A18]">My keepsakes</h1>
        <Link to="/create" className="btn-primary" data-testid="orders-create-button"><Plus size={20} /> New keepsake</Link>
      </div>
      {!orders.length && <p className="paper-card mt-8 p-8 text-lg text-[#4A3B32]" data-testid="orders-empty">You haven't started a keepsake yet. Tap "New keepsake" to begin.</p>}
      <div className="mt-8 space-y-5">
        {orders.map((o) => {
          const editing = ["draft", "pending_payment"].includes(o.status);
          const img = orderImage(o, stickerSrc);
          return (
            <div key={o.order_id} className="paper-card flex flex-col gap-5 p-5 sm:flex-row sm:items-center" data-testid={`order-card-${o.order_id}`}>
              {img ? <img src={img} alt="" className="h-24 w-24 shrink-0 rounded-md object-cover shadow" data-testid={`order-image-${o.order_id}`} /> : <div className="h-24 w-24 shrink-0 rounded-md bg-[#F2EBE1]" />}
              <div className="flex-1">
                <p className="font-serif text-2xl font-semibold">{o.title || "Untitled keepsake"}</p>
                <p className="text-lg text-[#5C4A3E]" data-testid={`order-status-${o.order_id}`}>{statusText(o)}</p>
              </div>
              <Link to={editing ? `/create/${o.order_id}` : `/orders/${o.order_id}`} className={editing ? "btn-primary" : "btn-outline"} data-testid={`order-open-${o.order_id}`}>
                {editing ? `Continue (step ${o.step} of 7)` : "View status"}
              </Link>
            </div>
          );
        })}
      </div>
    </div>
  );
}
